import { getDataManageList } from "../../../../services/activitySign/dataManage";

const initState = {
  dataManageList: [],
  queries: {
    name: "",
    typeId: "",
    status: ""
  }, // 搜索条件
  spinProps: {
    spinning: false,
    tip: "加载中"
  },
  pageInfo: {
    page: 1,
    pageSize: 10,
    totalElements: 1
  }
};

export default {
  namespace: "dataManage",

  state: initState,

  effects: {
    *fetchDataManageList({ params }, { call, put }) {
      try {
        yield put({
          type: "save",
          payload: {
            spinProps: {
              spinning: true,
              tip: "加载中"
            }
          }
        });
        const response = yield call(getDataManageList, params);
        const { page, pageSize, totalElements, content } = response;
        const { name = "", typeId = "", status = "" } = params;
        yield put({
          type: "save",
          payload: {
            dataManageList: content,
            pageInfo: {
              page,
              pageSize,
              totalElements
            },
            queries: {
              name,
              typeId,
              status
            },
            spinProps: {
              spinning: false
            }
          }
        });
        return Promise.resolve(response);
      } catch (error) {
        yield put({
          type: "save",
          payload: {
            spinProps: {
              spinning: false
            }
          }
        });
        return Promise.reject(error);
      }
    }
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload
      };
    },
    reset() {
      return {
        ...initState
      };
    }
  }
};
